// extracted by mini-css-extract-plugin
module.exports = {"container":"DTRList_container__U_KHz"};